import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesSecurityLevelDeleteRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-security-level-delete',
	path: '/secure/admin/DeleteIssueSecurityLevel!default.jspa',
};
